export default "/images/vendor/flag-icons/flags/1x1/cc.svg?1e40e3dea8a00cbaf5a107ea56117914";